import React from "react";
import PopoverText from "../PopoverText";
import { ReactComponent as InfoIcon } from "../../assets/info-icon-green.svg";
import BoxComponent from "../BoxComponent";
import "./index.scss";

const MetricSummaryCard = React.memo(
  ({
    title,
    rawValue,
    value,
    infoDescription,
    targetLabel,
    targetValue,
    rangeLabel,
    rangeValue,
    icon,
  }) => {
    if (rawValue === null || rawValue === undefined) {
      return null;
    }

    const normalizedValue = String(rawValue).trim().toLowerCase();
    const numericValue = Number.parseFloat(normalizedValue);
    if (
      !normalizedValue ||
      normalizedValue === "none" ||
      (!Number.isNaN(numericValue) && numericValue === 0)
    ) {
      return null;
    }
    const Icon = icon;
    const isSummaryCard = !targetValue && !rangeValue;

    return (
      <BoxComponent
        className={`metric-summary-card ${
          isSummaryCard ? "metric-summary-card--summary" : ""
        }`}
      >
        <div className="metric-summary-card__header">
          <div className="metric-summary-card__title-wrap">
            <Icon
              aria-label="metric icon"
              className="metric-summary-card__metric-icon"
            />
            <div className="metric-summary-card__heading-content">
              <div className="metric-summary-card__title">{title}</div>
              <div className="metric-summary-card__value">{value}</div>
            </div>
            <PopoverText
              descriptionText={infoDescription}
              descriptor={
                <InfoIcon className="metric-summary-card__info-icon" />
              }
            />
          </div>
        </div>

        {targetValue || rangeValue ? (
          <div className="metric-summary-card__range">
            {targetValue ? (
              <div className="metric-summary-card__meta">
                <span className="metric-summary-card__meta-label">
                  {targetLabel}
                </span>{" "}
                {targetValue}
              </div>
            ) : null}
            {rangeValue ? (
              <div className="metric-summary-card__meta">
                <span className="metric-summary-card__meta-label">
                  {rangeLabel}
                </span>{" "}
                {rangeValue}
              </div>
            ) : null}
          </div>
        ) : null}

      </BoxComponent>
    );
  }
);

export default MetricSummaryCard;
